import { addDays, differenceInCalendarDays } from "date-fns";

export const PEAK_FEE = 500;
export const PET_FEE = 200;
const PEAK = ["12-24", "12-25", "12-31", "1-1"];

export const isPeak = (d) => PEAK.includes(`${d.getMonth() + 1}-${d.getDate()}`);

export const brl = (v) => (v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export function calcQuote({ chalet, range, pet, deco }) {
  const nights = range?.from && range?.to ? Math.max(0, differenceInCalendarDays(range.to, range.from)) : 0;
  let peakNights = 0;
  for (let i = 0; i < nights; i += 1) if (isPeak(addDays(range.from, i))) peakNights += 1;
  const base = nights * (chalet?.price ?? 0);
  const peakTotal = peakNights * PEAK_FEE;
  const petTotal = pet ? PET_FEE : 0;
  const decoTotal = deco?.price ?? 0;
  return { nights, peakNights, base, peakTotal, petTotal, decoTotal, total: base + peakTotal + petTotal + decoTotal };
}
